import { jsx as s, jsxs as l } from "react/jsx-runtime";
import { c as r } from "./index-65016bfa.mjs";
import { useCallback as M } from "react";
import n, { css as m } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as b } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Image as h } from "./image.js";
import { Link as $ } from "./link.js";
import { Tag as L } from "./tags.js";
import { u as c } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "./Aria-f5e019e2.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./childrenCountCheck-785fa19a.mjs";
const C = n.div`
  &.Image__Content {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.ImageContent)}
  }
`, I = n.span`
  &.Label {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.Label)}
  }
`, k = n.div`
  &.Footer {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.Footer)}
  }
`, _ = n.div`
  &.MegaMenu {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.Main)}
  }
`, d = n.div`
  &.Content {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.Content)}
  }
`, N = n($)`
  &&.Link__Conatiner {
    ${({
  theme: {
    components: { megaMenu: e }
  }
}) => m(e.LinkContainer)}
  }
`, D = ({ items: e, onClick: a, onKeyDown: i, imageVariant: u = "none" }) => {
  const g = b({ label: "Mega Menu" }), f = M(
    (t, o) => {
      (t.key === "Enter" || t.key === " ") && (i == null || i(t, o));
    },
    [i]
  );
  return /* @__PURE__ */ s(
    _,
    {
      className: r(["MegaMenu"]),
      ...g,
      children: e.map((t, o) => /* @__PURE__ */ l(
        d,
        {
          className: r(["Content"]),
          children: [
            /* @__PURE__ */ l(
              C,
              {
                tabIndex: 0,
                onClick: (p) => {
                  a == null || a(p, o);
                },
                role: "button",
                id: `ImageWrapper-${c(`${o}`)}`,
                className: r(["Image__Content"]),
                onKeyDown: (p) => f(p, o),
                children: [
                  /* @__PURE__ */ s(
                    h,
                    {
                      objectFit: "fill",
                      ...t == null ? void 0 : t.imageProps,
                      variant: u,
                      ratio: "2:1"
                    }
                  ),
                  /* @__PURE__ */ l(k, { className: r(["Footer"]), children: [
                    /* @__PURE__ */ s(I, { className: r(["Label"]), children: t.label }),
                    t.tagProps && /* @__PURE__ */ s(L, { ...t.tagProps })
                  ] })
                ]
              }
            ),
            t.linkProps && /* @__PURE__ */ s(
              N,
              {
                className: r(["Link__Conatiner"]),
                tabIndex: -1,
                id: `Link-${c(`${o}`)}`,
                ...t.linkProps,
                size: "small",
                ref: null
              }
            )
          ]
        },
        c(`${o}`)
      ))
    }
  );
};
export {
  D as MegaMenu
};
